angular.module('unica_auth.auth_services')

.factory('ForgottenPasswordService', function ($http, getBaseApiURL, Session) {

	var forgottenPasswordService = {};

	forgottenPasswordService.forgottenPasswordRequest = function ( fiscal_code, agency_code ) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/auth/forgotten-password',
			data: {
				fiscal_code: fiscal_code,
				agency_code: agency_code
			}
		}).then(function(result) {

			if (result) {
				Session.destroy();
				return true;
			} else {
				return false;
			}

		});
	};

	return forgottenPasswordService;
});